// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-title-main {
  padding-top: var(--spacing-extra-big);
}
.radio-group-request-type {
  margin-top: var(--spacing-small);
}
.radio-request-type {
  border: 1px solid var(--color-neutral-light);
  border-radius: var(--border-radius-input) !important;
  padding: var(--spacing-small);
}
.container-term-span span {
  display: list-item;
  list-style-type: disc;
}
.link-user-terms {
  color: var(--color-highlight);
}
.link-user-terms:hover {
  color: var(--color-highlight-lighter);
}
.margin-top-extra-small {
  margin-top: var(--spacing-extra-small);
}
.margin-top-small {
  margin-top: var(--spacing-small);
}
.margin-top-regular {
  margin-top: var(--spacing-regular);
}
.margin-top-big {
  margin-top: var(--spacing-big);
}
.margin-top-extra-big {
  margin-top: var(--spacing-extra-big);
}
.width-100 {
  width: 100%;
}
.form-item-bar-code {
  margin-bottom: 0px;
}
.container-bar-code-length {
  display: flex;
  flex-direction: row;
  justify-content: end;
  margin-top: var(--spacing-extra-small);
}
.bar-code-length-span {
  font-size: var(--font-paragraph);
  font-weight: 500;
  color: var(--color-neutral-dark-darker);
}
.form-item-agreed-terms label.vert-check {
  margin-top: var(--spacing-extra-small);
}
.modal-rules-bill-payment div.ant-modal-content {
  padding: var(--spacing-extra-big) !important;
}
.modal-confirm-details-payment div.ant-modal-content {
  padding-bottom: var(--spacing-extra-big) !important;
}
.container-summary-product {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  border-radius: var(--border-radius-base);
  padding: var(--spacing-small);
}
.font-weight-500 {
  font-weight: 500;
}
.description-limit-label {
  color: var(--color-neutral-dark-lighter);
}
.table-product-service-concierge .ant-table-row-expand-icon-cell {
  vertical-align: middle;
  text-align: center;
}
.container-client-information-sub {
  margin-top: var(--spacing-big);
}
.btn-upload .ant-upload-list {
  margin-top: 8px !important;
}
.container-checkbox-budget {
  margin-top: var(--spacing-big);
}
.container-checkbox-budget .ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--color-highlight) !important;
}
.container-concierge-information-main {
  width: 55%;
  margin-top: var(--spacing-big);
}
.radio-request-type:hover {
  border-color: var(--color-highlight);
}
.autocomplete-client {
  margin-top: var(--spacing-small);
}
.form-new-solicitation .ant-form-item-control-input label.vert-input-label {
  font-family: var(--font-family);
  font-size: var(--font-paragraph);
  font-weight: 500;
  color: var(--color-neutral-light);
}
.text-area-description {
  border-radius: var(--border-radius-primary);
  padding: var(--spacing-small);
  border-width: var(--border-width);
  border-color: var(--color-border) !important;
  border-style: solid;
  cursor: pointer;
  resize: none !important;
  min-height: 120px !important;
}
.text-area-description::placeholder {
  font-family: var(--font-family);
  font-size: var(--font-paragraph);
  font-weight: 500;
  color: var(--color-neutral-light);
}
form.form-new-solicitation .ant-form-item-has-error .ant-input {
  border-color: var(--color-error) !important;
}
.text-area-description:hover {
  border-color: var(--color-border);
}
.text-area-description:focus {
  border-color: var(--color-detached) !important;
  box-shadow: none !important;
}
.radio-selected {
  border-color: var(--color-highlight);
}
.span-button-return {
  color: var(--color-highlight-lighter);
  margin-right: var(--spacing-extra-small);
}
.span-button-continue {
  color: var(--color-button-text);
  margin-right: var(--spacing-extra-small);
}
.span-button {
  color: var(--color-highlight);
}
.table-col-vertical-align {
  vertical-align: middle;
}
.text-request-title {
  margin-top: var(--spacing-small);
}
.text-group-balance {
  margin-top: var(--spacing-extra-small);
}
.text-title {
  font-size: var(--font-giant);
  font-weight: 600;
  color: var(--color-neutral-dark);
}
.text-subtitle {
  font-size: var(--font-medium);
  font-weight: 600;
  color: var(--color-neutral-dark);
}
.container-back-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.text-back-button {
  margin-left: var(--spacing-extra-small);
  font-size: var(--font-medium);
  font-weight: 500;
  color: var(--color-highlight);
}
.button-continue {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.container-steps-new-solicitation {
  width: 55%;
  margin-top: var(--spacing-regular);
}
.container-steps-new-solicitation .ant-steps-icon .ant-steps-finish-icon svg {
  fill: var(--color-highlight-darker);
}
.button-upload-file .ant-btn-loading-icon {
  margin-inline-end: 0 !important;
}
.container-category-sub-category {
  margin-top: var(--spacing-regular);
}
.select-category.ant-select-single {
  height: 0;
}
.text-weight-modal-confirmation {
  font-weight: 600 !important;
}
.modal-text-align {
  text-align: center !important;
}
.modal-text-align div.ant-modal-content {
  padding: var(--spacing-regular) !important;
}
.modal-text-padding div.ant-modal-content {
  padding: var(--spacing-regular) !important;
}
.margin-left-divider {
  margin-left: var(--spacing-extra-small);
}
.margin-top-divider {
  margin-top: var(--spacing-regular);
}
.margin-bottom-divider {
  margin-bottom: var(--spacing-small);
}
.color-title {
  color: var(--color-neutral-dark-darker) !important;
}
.text-area-input {
  border-radius: var(--border-radius-primary);
  padding: var(--spacing-small);
  border-width: var(--border-width);
  border-color: var(--color-border) !important;
  border-style: solid;
  cursor: pointer;
  resize: none !important;
  min-height: 64px !important;
  margin-top: var(--spacing-small);
}
.text-area-input:hover {
  border-color: var(--color-border);
}
.text-area-input:focus {
  border-color: var(--color-detached) !important;
  box-shadow: none !important;
}
.datepicker-delivery-popup .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-date-panel {
  width: 320px;
}
.datepicker-delivery-popup .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-date-panel .ant-picker-body {
  padding: var(--spacing-small);
  align-self: center;
}
.datepicker-delivery-popup .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-date-panel .ant-picker-header .ant-picker-header-view {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-extra-small);
}
.vert-datepicker.ant-picker .ant-picker-input > input {
  color: var(--color-neutral-light);
}
.ant-picker input[disabled]::placeholder {
  font-family: var(--font-family);
  font-size: var(--font-paragraph);
  font-weight: 500;
  color: var(--color-neutral-light);
}
form.form-new-solicitation .ant-form-item-has-error .ant-picker {
  border-color: var(--color-error) !important;
}
.form-items {
  margin-top: var(--spacing-regular);
  margin-bottom: var(--spacing-big);
}
.card-address {
  border-radius: var(--border-radius-base);
  padding: var(--spacing-regular);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  margin-bottom: var(--spacing-small);
}
.margin-button-approve {
  padding: var(--spacing-small) !important;
  margin-bottom: var(--spacing-regular);
  margin-right: var(--spacing-regular);
}
.margin-button-send {
  padding: var(--spacing-small) !important;
  margin-bottom: var(--spacing-extra-small);
  margin-left: var(--spacing-regular);
}
.margin-bottom-divider-title {
  margin-bottom: var(--spacing-regular) !important;
}
.button-cancel-continue {
  color: var(--color-button-text);
  margin: 0 var(--spacing-regular) var(--spacing-extra-small) var(--spacing-regular);
}
.text-align-details {
  text-align: justify;
}
.field-disabled {
  background-color: var(--color-neutral-light-lighter) !important;
  color: var(--color-neutral-light) !important;
}
.space-description {
  height: var(--spacing-giant);
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.view-details-concierge-modal {
  text-align: center !important;
}
.view-details-concierge-modal div.ant-modal-content {
  padding: var(--spacing-regular) !important;
}
.delete-success-concierge-item-modal {
  text-align: center !important;
}
.delete-success-concierge-item-modal div.ant-modal-content {
  padding: var(--spacing-regular) !important;
}
.delete-concierge-item-modal {
  text-align: center !important;
}
.delete-concierge-item-modal div.ant-modal-content {
  padding: var(--spacing-regular) !important;
}
.loading-space {
  width: 100%;
  margin-top: var(--spacing-extra-big);
}
.error-space {
  width: 100%;
  margin-top: var(--spacing-big);
  text-align: center;
}
.text-not-found {
  color: var(--color-neutral-dark-lighter);
  font-size: var(--font-giant);
}
.padding-bottom-title {
  padding-bottom: var(--spacing-regular);
}
.vert-template-marketplace.select-dropdown-marketplace .category-list-disabled.ant-select-item-option-disabled {
  color: rgba(89, 88, 90, 0.25) !important;
}
.container-confirm-details-payment {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.confirm-details-payment-text {
  font-size: var(--font-big);
  color: var(--color-neutral-dark-darker);
  font-weight: 600;
}
.confirm-details-payment-details {
  color: var(--color-neutral-dark);
  font-size: var(--font-paragraph);
  font-weight: 500;
}
.button-confirm-details-payment {
  width: 100%;
  padding: var(--spacing-extra-small);
}
.container-payment-rules-details {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.payment-rules-details-text-main {
  font-size: var(--font-big);
  font-weight: 600;
  color: var(--color-neutral-dark-darker);
  margin-left: var(--spacing-small);
}
.payment-rules-details-text-sub {
  font-size: var(--font-paragraph);
  font-weight: 400;
  color: var(--color-neutral-dark-darker);
}
.payment-rules-number-container {
  padding: var(--spacing-extra-small) 13px;
  border-radius: 50%;
  border-width: 1.5px;
  border-style: solid;
  border-color: var(--color-neutral-dark-darker);
}
.payment-rules-number {
  font-size: var(--font-paragraph);
  color: var(--color-neutral-dark);
  font-weight: 500;
}
.payment-rules-number-text {
  font-size: var(--font-paragraph);
  font-weight: 400;
  color: var(--color-neutral-dark);
}
.container-user-terms-main {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.container-user-terms-sub {
  display: flex;
  flex-direction: column;
}
.container-user-terms-important-message-main {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.container-user-terms-important-message-sub {
  display: flex;
  flex-direction: column;
}
.user-terms-important-message-text {
  font-size: var(--font-medium);
  font-weight: 600;
  color: var(--color-neutral-dark-darker);
}
.user-terms-text {
  font-size: var(--font-big);
  font-weight: 600;
  color: var(--color-neutral-dark-darker);
}
@media screen and (max-width: 1550px) {
  .modal-confirm-details-payment {
    width: 35% !important;
  }
}
@media screen and (max-width: 1120px) {
  .modal-confirm-details-payment {
    width: 50% !important;
  }
}
@media screen and (max-width: 780px) {
  .modal-confirm-details-payment {
    width: 70% !important;
  }
}
@media screen and (max-width: 1710px) {
  .modal-rules-bill-payment {
    width: 48% !important;
  }
}
@media screen and (max-width: 1410px) {
  .modal-rules-bill-payment {
    width: 55% !important;
  }
}
@media screen and (max-width: 1250px) {
  .modal-rules-bill-payment {
    width: 70% !important;
  }
}
@media screen and (max-width: 980px) {
  .modal-rules-bill-payment {
    width: 90% !important;
  }
}
@media screen and (max-width: 750px) {
  .modal-rules-bill-payment {
    width: 100% !important;
  }
}
@media screen and (max-width: 1500px) {
  .container-concierge-information-main,
  .container-steps-new-solicitation {
    width: 70%;
  }
}
@media screen and (max-width: 1200px) {
  .container-concierge-information-main,
  .container-steps-new-solicitation {
    width: 90%;
  }
}
@media screen and (max-width: 960px) {
  .container-concierge-information-main,
  .container-steps-new-solicitation {
    width: 100%;
  }
}
@media screen and (max-width: 570px) {
  .width-modal {
    width: 500px !important;
  }
}
.button-concierge.vert-button[disabled].ant-btn-default span {
  color: var(--color-neutral);
}
.button-concierge.vert-button:not([disabled]).ant-btn-highlight {
  background-color: var(--color-highlight) !important;
}
.button-concierge.vert-button:not([disabled]).ant-btn-highlight:hover {
  background-color: var(--color-highlight-darker) !important;
}
.button-concierge.vert-button:not([disabled]).ant-btn-default {
  border-color: var(--color-highlight) !important;
  color: var(--color-highlight) !important;
}
.button-concierge.vert-button:not([disabled]).ant-btn-default:hover {
  border-color: var(--color-border) !important;
}
.radio-selected:hover {
  border-color: var(--color-highlight);
}
.ant-radio-wrapper:hover .ant-radio-inner {
  border-color: var(--color-highlight) !important;
}
.vert-radio.ant-radio-wrapper .ant-radio .ant-radio-inner::after {
  background-color: var(--color-highlight) !important;
  transform: scale(0.7) !important;
}
.ant-radio-wrapper .ant-radio.ant-radio-checked .ant-radio-inner {
  border-color: var(--color-highlight) !important;
}
.ant-radio-checked::after {
  border: var(--color-highlight-darker) !important;
}
.customer-search .ant-select-selection-search,
.supplier-search .ant-select-selection-search {
  padding-left: var(--spacing-small);
}
@media (max-width: 425px) {
  .collum-btn-continue button {
    display: flex;
    align-items: center;
    flex-direction: row !important;
    gap: 0px !important;
  }
}
.text-title-finish {
  font-size: var(--font-big);
  font-weight: 600;
  color: var(--color-neutral-dark);
}
.quotation-file {
  margin-left: 10px;
  border-radius: var(--border-radius-input) !important;
}
.quotation-file:hover {
  border-color: var(--color-highlight);
}
.important-info > span {
  display: flex;
  align-items: center;
  gap: 5px;
}
.important-info > span svg {
  font-size: 14px;
  margin-bottom: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less"],"names":[],"mappings":"AAAA;EACI,qCAAA;AACJ;AAEA;EACI,gCAAA;AAAJ;AAGA;EACI,4CAAA;EACA,oDAAA;EACA,6BAAA;AADJ;AAIA;EAEQ,kBAAA;EACA,qBAAA;AAHR;AAOA;EACI,6BAAA;AALJ;AAQA;EACI,qCAAA;AANJ;AASA;EACI,sCAAA;AAPJ;AAUA;EACI,gCAAA;AARJ;AAWA;EACI,kCAAA;AATJ;AAYA;EACI,8BAAA;AAVJ;AAaA;EACI,oCAAA;AAXJ;AAcA;EACI,WAAA;AAZJ;AAeA;EACI,kBAAA;AAbJ;AAgBA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,sCAAA;AAdJ;AAiBA;EACI,gCAAA;EACA,gBAAA;EACA,uCAAA;AAfJ;AAkBA;EAEQ,sCAAA;AAjBR;AAqBA;EAEQ,4CAAA;AApBR;AAwBA;EAEQ,mDAAA;AAvBR;AA2BA;EACI,+CAAA;EACA,wCAAA;EACA,6BAAA;AAzBJ;AA4BA;EACI,gBAAA;AA1BJ;AA6BA;EACI,wCAAA;AA3BJ;AA8BA;EAEQ,sBAAA;EACA,kBAAA;AA7BR;AAiCA;EACI,8BAAA;AA/BJ;AAkCA;EAEQ,0BAAA;AAjCR;AAqCA;EACI,8BAAA;AAnCJ;AAkCA;EAIQ,mDAAA;AAnCR;AAuCA;EACI,UAAA;EACA,8BAAA;AArCJ;AAwCA;EACI,oCAAA;AAtCJ;AAyCA;EACI,gCAAA;AAvCJ;AA0CA;EAGY,+BAAA;EACA,gCAAA;EACA,gBAAA;EACA,iCAAA;AA1CZ;AA+CA;EACI,2CAAA;EACA,6BAAA;EACA,iCAAA;EACA,4CAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,4BAAA;AA7CJ;AA+CI;EACI,+BAAA;EACA,gCAAA;EACA,gBAAA;EACA,iCAAA;AA7CR;AAiDA;EAGY,2CAAA;AAjDZ;AAsDA;EACI,iCAAA;AApDJ;AAuDA;EACI,8CAAA;EACA,2BAAA;AArDJ;AAwDA;EACI,oCAAA;AAtDJ;AAyDA;EACI,qCAAA;EACA,wCAAA;AAvDJ;AA0DA;EACI,+BAAA;EACA,wCAAA;AAxDJ;AA2DA;EACI,6BAAA;AAzDJ;AA4DA;EACI,sBAAA;AA1DJ;AA6DA;EACI,gCAAA;AA3DJ;AA8DA;EACI,sCAAA;AA5DJ;AA+DA;EACI,4BAAA;EACA,gBAAA;EACA,gCAAA;AA7DJ;AAgEA;EACI,6BAAA;EACA,gBAAA;EACA,gCAAA;AA9DJ;AAiEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA/DJ;AAkEA;EACI,uCAAA;EACA,6BAAA;EACA,gBAAA;EACA,6BAAA;AAhEJ;AAmEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAjEJ;AAoEA;EACI,UAAA;EACA,kCAAA;AAlEJ;AAgEA;EAKQ,mCAAA;AAlER;AAsEA;EAEQ,+BAAA;AArER;AAyEA;EACI,kCAAA;AAvEJ;AA0EA;EACI,SAAA;AAxEJ;AA2EA;EACI,2BAAA;AAzEJ;AA4EA;EACI,6BAAA;AA1EJ;AAyEA;EAIQ,0CAAA;AA1ER;AA8EA;EAEQ,0CAAA;AA7ER;AAiFA;EACI,uCAAA;AA/EJ;AAkFA;EACI,kCAAA;AAhFJ;AAmFA;EACI,mCAAA;AAjFJ;AAoFA;EACI,kDAAA;AAlFJ;AAqFA;EACI,2CAAA;EACA,6BAAA;EACA,iCAAA;EACA,4CAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,2BAAA;EACA,gCAAA;AAnFJ;AAsFA;EACI,iCAAA;AApFJ;AAuFA;EACI,8CAAA;EACA,2BAAA;AArFJ;AAwFA;EAKoB,YAAA;AA1FpB;AAqFA;EAQwB,6BAAA;EACA,kBAAA;AA1FxB;AAiFA;EAc4B,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;AA5F5B;AAqGA;EAGY,iCAAA;AArGZ;AA4GQ;EACI,+BAAA;EACA,gCAAA;EACA,gBAAA;EACA,iCAAA;AA1GZ;AA+GA;EACI,2CAAA;AA7GJ;AAgHA;EACI,kCAAA;EACA,iCAAA;AA9GJ;AAiHA;EACI,wCAAA;EACA,+BAAA;EACA,+CAAA;EACA,mCAAA;AA/GJ;AAkHA;EACI,wCAAA;EACA,qCAAA;EACA,oCAAA;AAhHJ;AAmHA;EACI,wCAAA;EACA,yCAAA;EACA,mCAAA;AAjHJ;AAoHA;EACI,gDAAA;AAlHJ;AAqHA;EACI,+BAAA;EACA,kFAAA;AAnHJ;AAsHA;EACI,mBAAA;AApHJ;AAuHA;EACI,+DAAA;EACA,4CAAA;AArHJ;AAwHA;EACI,4BAAA;EACA,6BAAA;EACA,4BAAA;AAtHJ;AAyHA;EACI,6BAAA;AAvHJ;AAsHA;EAIQ,0CAAA;AAvHR;AA2HA;EACI,6BAAA;AAzHJ;AAwHA;EAIQ,0CAAA;AAzHR;AA6HA;EACI,6BAAA;AA3HJ;AA0HA;EAIQ,0CAAA;AA3HR;AA+HA;EACI,WAAA;EACA,oCAAA;AA7HJ;AAgIA;EACI,WAAA;EACA,8BAAA;EACA,kBAAA;AA9HJ;AAiIA;EACI,wCAAA;EACA,4BAAA;AA/HJ;AAkIA;EACI,sCAAA;AAhIJ;AAmIA;EACI,wCAAA;AAjIJ;AAoIA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAlIJ;AAqIA;EACI,0BAAA;EACA,uCAAA;EACA,gBAAA;AAnIJ;AAsIA;EACI,gCAAA;EACA,gCAAA;EACA,gBAAA;AApIJ;AAuIA;EACI,WAAA;EACA,mCAAA;AArIJ;AAwIA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAtIJ;AAyIA;EACI,0BAAA;EACA,gBAAA;EACA,uCAAA;EACA,iCAAA;AAvIJ;AA0IA;EACI,gCAAA;EACA,gBAAA;EACA,uCAAA;AAxIJ;AA2IA;EACI,wCAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;AAzIJ;AA4IA;EACI,gCAAA;EACA,gCAAA;EACA,gBAAA;AA1IJ;AA6IA;EACI,gCAAA;EACA,gBAAA;EACA,gCAAA;AA3IJ;AA8IA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AA5IJ;AA+IA;EACI,aAAA;EACA,sBAAA;AA7IJ;AAgJA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AA9IJ;AAiJA;EACI,aAAA;EACA,sBAAA;AA/IJ;AAkJA;EACI,6BAAA;EACA,gBAAA;EACA,uCAAA;AAhJJ;AAmJA;EACI,0BAAA;EACA,gBAAA;EACA,uCAAA;AAjJJ;AAoJA;EACI;IACI,qBAAA;EAlJN;AACF;AAqJA;EACI;IACI,qBAAA;EAnJN;AACF;AAsJA;EACI;IACI,qBAAA;EApJN;AACF;AAuJA;EACI;IACI,qBAAA;EArJN;AACF;AAwJA;EACI;IACI,qBAAA;EAtJN;AACF;AAyJA;EACI;IACI,qBAAA;EAvJN;AACF;AA0JA;EACI;IACI,qBAAA;EAxJN;AACF;AA2JA;EACI;IACI,sBAAA;EAzJN;AACF;AA4JA;EAEI;;IAEI,UAAA;EA3JN;AACF;AA8JA;EAEI;;IAEI,UAAA;EA7JN;AACF;AAgKA;EAEI;;IAEI,WAAA;EA/JN;AACF;AAkKA;EAEI;IACI,uBAAA;EAjKN;AACF;AAqKA;EAEQ,2BAAA;AApKR;AAwKA;EACI,mDAAA;AAtKJ;AAyKA;EACI,0DAAA;AAvKJ;AA0KA;EACI,+CAAA;EACA,wCAAA;AAxKJ;AA2KA;EACI,4CAAA;AAzKJ;AA6KA;EACI,oCAAA;AA3KJ;AA8KA;EAEQ,+CAAA;AA7KR;AAkLI;EACI,mDAAA;EACA,gCAAA;AAhLR;AAoLA;EACI,+CAAA;AAlLJ;AAqLA;EACI,gDAAA;AAnLJ;AAsLA;;EAEQ,kCAAA;AApLR;AAwLA;EACI;IAEI,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,mBAAA;EAvLN;AACF;AA2LA;EACI,0BAAA;EACA,gBAAA;EACA,gCAAA;AAzLJ;AA4LA;EACI,iBAAA;EACA,oDAAA;AA1LJ;AA6LA;EACI,oCAAA;AA3LJ;AA8LA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AA5LJ;AAyLA;EAMQ,eAAA;EACA,kBAAA;AA5LR","sourcesContent":[".container-title-main {\n    padding-top: var(--spacing-extra-big);\n}\n\n.radio-group-request-type {\n    margin-top: var(--spacing-small);\n}\n\n.radio-request-type {\n    border: 1px solid var(--color-neutral-light);\n    border-radius: var(--border-radius-input) !important;\n    padding: var(--spacing-small);\n}\n\n.container-term-span {\n    span {\n        display: list-item;\n        list-style-type: disc;\n    }\n}\n\n.link-user-terms {\n    color: var(--color-highlight);\n}\n\n.link-user-terms:hover {\n    color: var(--color-highlight-lighter);\n}\n\n.margin-top-extra-small {\n    margin-top: var(--spacing-extra-small);\n}\n\n.margin-top-small {\n    margin-top: var(--spacing-small);\n}\n\n.margin-top-regular {\n    margin-top: var(--spacing-regular)\n}\n\n.margin-top-big {\n    margin-top: var(--spacing-big);\n}\n\n.margin-top-extra-big {\n    margin-top: var(--spacing-extra-big);\n}\n\n.width-100 {\n    width: 100%;\n}\n\n.form-item-bar-code {\n    margin-bottom: 0px;\n}\n\n.container-bar-code-length {\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n    margin-top: var(--spacing-extra-small);\n}\n\n.bar-code-length-span {\n    font-size: var(--font-paragraph);\n    font-weight: 500;\n    color: var(--color-neutral-dark-darker);\n}\n\n.form-item-agreed-terms {\n    label.vert-check {\n        margin-top: var(--spacing-extra-small);\n    }\n}\n\n.modal-rules-bill-payment {\n    div.ant-modal-content {\n        padding: var(--spacing-extra-big) !important;\n    }\n}\n\n.modal-confirm-details-payment {\n    div.ant-modal-content {\n        padding-bottom: var(--spacing-extra-big) !important;\n    }\n}\n\n.container-summary-product {\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);\n    border-radius: var(--border-radius-base);\n    padding: var(--spacing-small);\n}\n\n.font-weight-500 {\n    font-weight: 500;\n}\n\n.description-limit-label {\n    color: var(--color-neutral-dark-lighter);\n}\n\n.table-product-service-concierge {\n    .ant-table-row-expand-icon-cell {\n        vertical-align: middle;\n        text-align: center;\n    }\n}\n\n.container-client-information-sub {\n    margin-top: var(--spacing-big);\n}\n\n.btn-upload {\n    .ant-upload-list {\n        margin-top: 8px !important;\n    }\n}\n\n.container-checkbox-budget {\n    margin-top: var(--spacing-big);\n\n    .ant-checkbox-checked .ant-checkbox-inner {\n        background-color: var(--color-highlight) !important;\n    }\n}\n\n.container-concierge-information-main {\n    width: 55%;\n    margin-top: var(--spacing-big);\n}\n\n.radio-request-type:hover {\n    border-color: var(--color-highlight);\n}\n\n.autocomplete-client {\n    margin-top: var(--spacing-small);\n}\n\n.form-new-solicitation {\n    .ant-form-item-control-input {\n        label.vert-input-label {\n            font-family: var(--font-family);\n            font-size: var(--font-paragraph);\n            font-weight: 500;\n            color: var(--color-neutral-light);\n        }\n    }\n}\n\n.text-area-description {\n    border-radius: var(--border-radius-primary);\n    padding: var(--spacing-small);\n    border-width: var(--border-width);\n    border-color: var(--color-border) !important;\n    border-style: solid;\n    cursor: pointer;\n    resize: none !important;\n    min-height: 120px !important;\n\n    &::placeholder {\n        font-family: var(--font-family);\n        font-size: var(--font-paragraph);\n        font-weight: 500;\n        color: var(--color-neutral-light);\n    }\n}\n\nform.form-new-solicitation {\n    .ant-form-item-has-error {\n        .ant-input {\n            border-color: var(--color-error) !important;\n        }\n    }\n}\n\n.text-area-description:hover {\n    border-color: var(--color-border);\n}\n\n.text-area-description:focus {\n    border-color: var(--color-detached) !important;\n    box-shadow: none !important;\n}\n\n.radio-selected {\n    border-color: var(--color-highlight);\n}\n\n.span-button-return {\n    color: var(--color-highlight-lighter);\n    margin-right: var(--spacing-extra-small);\n}\n\n.span-button-continue {\n    color: var(--color-button-text);\n    margin-right: var(--spacing-extra-small);\n}\n\n.span-button {\n    color: var(--color-highlight);\n}\n\n.table-col-vertical-align {\n    vertical-align: middle;\n}\n\n.text-request-title {\n    margin-top: var(--spacing-small);\n}\n\n.text-group-balance {\n    margin-top: var(--spacing-extra-small);\n}\n\n.text-title {\n    font-size: var(--font-giant);\n    font-weight: 600;\n    color: var(--color-neutral-dark);\n}\n\n.text-subtitle {\n    font-size: var(--font-medium);\n    font-weight: 600;\n    color: var(--color-neutral-dark);\n}\n\n.container-back-button {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n\n.text-back-button {\n    margin-left: var(--spacing-extra-small);\n    font-size: var(--font-medium);\n    font-weight: 500;\n    color: var(--color-highlight);\n}\n\n.button-continue {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n\n.container-steps-new-solicitation {\n    width: 55%;\n    margin-top: var(--spacing-regular);\n\n    .ant-steps-icon .ant-steps-finish-icon svg {\n        fill: var(--color-highlight-darker);\n    }\n}\n\n.button-upload-file {\n    .ant-btn-loading-icon {\n        margin-inline-end: 0 !important;\n    }\n}\n\n.container-category-sub-category {\n    margin-top: var(--spacing-regular);\n}\n\n.select-category.ant-select-single {\n    height: 0;\n}\n\n.text-weight-modal-confirmation {\n    font-weight: 600 !important;\n}\n\n.modal-text-align {\n    text-align: center !important;\n\n    div.ant-modal-content {\n        padding: var(--spacing-regular) !important;\n    }\n}\n\n.modal-text-padding {\n    div.ant-modal-content {\n        padding: var(--spacing-regular) !important;\n    }\n}\n\n.margin-left-divider {\n    margin-left: var(--spacing-extra-small);\n}\n\n.margin-top-divider {\n    margin-top: var(--spacing-regular);\n}\n\n.margin-bottom-divider {\n    margin-bottom: var(--spacing-small);\n}\n\n.color-title {\n    color: var(--color-neutral-dark-darker) !important;\n}\n\n.text-area-input {\n    border-radius: var(--border-radius-primary);\n    padding: var(--spacing-small);\n    border-width: var(--border-width);\n    border-color: var(--color-border) !important;\n    border-style: solid;\n    cursor: pointer;\n    resize: none !important;\n    min-height: 64px !important;\n    margin-top: var(--spacing-small);\n}\n\n.text-area-input:hover {\n    border-color: var(--color-border);\n}\n\n.text-area-input:focus {\n    border-color: var(--color-detached) !important;\n    box-shadow: none !important;\n}\n\n.datepicker-delivery-popup {\n    .ant-picker-panel-container {\n        .ant-picker-panel-layout {\n            .ant-picker-panel {\n                .ant-picker-date-panel {\n                    width: 320px;\n\n                    .ant-picker-body {\n                        padding: var(--spacing-small);\n                        align-self: center;\n                    }\n\n                    .ant-picker-header {\n                        .ant-picker-header-view {\n                            display: flex;\n                            align-items: center;\n                            justify-content: center;\n                            gap: var(--spacing-extra-small);\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.vert-datepicker.ant-picker {\n    .ant-picker-input {\n        > input {\n            color: var(--color-neutral-light);\n        }\n    }\n}\n\n.ant-picker {\n    input[disabled] {\n        &::placeholder {\n            font-family: var(--font-family);\n            font-size: var(--font-paragraph);\n            font-weight: 500;\n            color: var(--color-neutral-light);\n        }\n    }\n}\n\nform.form-new-solicitation .ant-form-item-has-error .ant-picker {\n    border-color: var(--color-error) !important;\n}\n\n.form-items {\n    margin-top: var(--spacing-regular);\n    margin-bottom: var(--spacing-big);\n}\n\n.card-address {\n    border-radius: var(--border-radius-base);\n    padding: var(--spacing-regular);\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);\n    margin-bottom: var(--spacing-small);\n}\n\n.margin-button-approve {\n    padding: var(--spacing-small) !important;\n    margin-bottom: var(--spacing-regular);\n    margin-right: var(--spacing-regular);\n}\n\n.margin-button-send {\n    padding: var(--spacing-small) !important;\n    margin-bottom: var(--spacing-extra-small);\n    margin-left: var(--spacing-regular);\n}\n\n.margin-bottom-divider-title {\n    margin-bottom: var(--spacing-regular) !important;\n}\n\n.button-cancel-continue {\n    color: var(--color-button-text);\n    margin: 0 var(--spacing-regular) var(--spacing-extra-small) var(--spacing-regular);\n}\n\n.text-align-details {\n    text-align: justify;\n}\n\n.field-disabled {\n    background-color: var(--color-neutral-light-lighter) !important;\n    color: var(--color-neutral-light) !important;\n}\n\n.space-description {\n    height: var(--spacing-giant);\n    padding-right: 0px !important;\n    padding-left: 0px !important;\n}\n\n.view-details-concierge-modal {\n    text-align: center !important;\n\n    div.ant-modal-content {\n        padding: var(--spacing-regular) !important;\n    }\n}\n\n.delete-success-concierge-item-modal {\n    text-align: center !important;\n\n    div.ant-modal-content {\n        padding: var(--spacing-regular) !important;\n    }\n}\n\n.delete-concierge-item-modal {\n    text-align: center !important;\n\n    div.ant-modal-content {\n        padding: var(--spacing-regular) !important;\n    }\n}\n\n.loading-space {\n    width: 100%;\n    margin-top: var(--spacing-extra-big);\n}\n\n.error-space {\n    width: 100%;\n    margin-top: var(--spacing-big);\n    text-align: center;\n}\n\n.text-not-found {\n    color: var(--color-neutral-dark-lighter);\n    font-size: var(--font-giant);\n}\n\n.padding-bottom-title {\n    padding-bottom: var(--spacing-regular);\n}\n\n.vert-template-marketplace.select-dropdown-marketplace .category-list-disabled.ant-select-item-option-disabled {\n    color: rgba(89, 88, 90, 0.25) !important;\n}\n\n.container-confirm-details-payment {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.confirm-details-payment-text {\n    font-size: var(--font-big);\n    color: var(--color-neutral-dark-darker);\n    font-weight: 600;\n}\n\n.confirm-details-payment-details {\n    color: var(--color-neutral-dark);\n    font-size: var(--font-paragraph);\n    font-weight: 500;\n}\n\n.button-confirm-details-payment {\n    width: 100%;\n    padding: var(--spacing-extra-small);\n}\n\n.container-payment-rules-details {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.payment-rules-details-text-main {\n    font-size: var(--font-big);\n    font-weight: 600;\n    color: var(--color-neutral-dark-darker);\n    margin-left: var(--spacing-small);\n}\n\n.payment-rules-details-text-sub {\n    font-size: var(--font-paragraph);\n    font-weight: 400;\n    color: var(--color-neutral-dark-darker);\n}\n\n.payment-rules-number-container {\n    padding: var(--spacing-extra-small) 13px;\n    border-radius: 50%;\n    border-width: 1.5px;\n    border-style: solid;\n    border-color: var(--color-neutral-dark-darker);\n}\n\n.payment-rules-number {\n    font-size: var(--font-paragraph);\n    color: var(--color-neutral-dark);\n    font-weight: 500;\n}\n\n.payment-rules-number-text {\n    font-size: var(--font-paragraph);\n    font-weight: 400;\n    color: var(--color-neutral-dark);\n}\n\n.container-user-terms-main {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.container-user-terms-sub {\n    display: flex;\n    flex-direction: column;\n}\n\n.container-user-terms-important-message-main {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.container-user-terms-important-message-sub {\n    display: flex;\n    flex-direction: column;\n}\n\n.user-terms-important-message-text {\n    font-size: var(--font-medium);\n    font-weight: 600;\n    color: var(--color-neutral-dark-darker);\n}\n\n.user-terms-text {\n    font-size: var(--font-big);\n    font-weight: 600;\n    color: var(--color-neutral-dark-darker);\n}\n\n@media screen and (max-width: 1550px) {\n    .modal-confirm-details-payment {\n        width: 35% !important;\n    }\n}\n\n@media screen and (max-width: 1120px) {\n    .modal-confirm-details-payment {\n        width: 50% !important;\n    }\n}\n\n@media screen and (max-width: 780px) {\n    .modal-confirm-details-payment {\n        width: 70% !important;\n    }\n}\n\n@media screen and (max-width: 1710px) {\n    .modal-rules-bill-payment {\n        width: 48% !important;\n    }\n}\n\n@media screen and (max-width: 1410px) {\n    .modal-rules-bill-payment {\n        width: 55% !important;\n    }\n}\n\n@media screen and (max-width: 1250px) {\n    .modal-rules-bill-payment {\n        width: 70% !important;\n    }\n}\n\n@media screen and (max-width: 980px) {\n    .modal-rules-bill-payment {\n        width: 90% !important;\n    }\n}\n\n@media screen and (max-width: 750px) {\n    .modal-rules-bill-payment {\n        width: 100% !important;\n    }\n}\n\n@media screen and (max-width: 1500px) {\n\n    .container-concierge-information-main,\n    .container-steps-new-solicitation {\n        width: 70%;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n\n    .container-concierge-information-main,\n    .container-steps-new-solicitation {\n        width: 90%;\n    }\n}\n\n@media screen and (max-width: 960px) {\n\n    .container-concierge-information-main,\n    .container-steps-new-solicitation {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: 570px) {\n\n    .width-modal {\n        width: 500px !important;\n    }\n}\n\n//Button\n.button-concierge.vert-button[disabled].ant-btn-default {\n    span {\n        color: var(--color-neutral);\n    }\n}\n\n.button-concierge.vert-button:not([disabled]).ant-btn-highlight {\n    background-color: var(--color-highlight) !important;\n}\n\n.button-concierge.vert-button:not([disabled]).ant-btn-highlight:hover {\n    background-color: var(--color-highlight-darker) !important;\n}\n\n.button-concierge.vert-button:not([disabled]).ant-btn-default {\n    border-color: var(--color-highlight) !important;\n    color: var(--color-highlight) !important;\n}\n\n.button-concierge.vert-button:not([disabled]).ant-btn-default:hover {\n    border-color: var(--color-border) !important;\n}\n\n//Radio\n.radio-selected:hover {\n    border-color: var(--color-highlight);\n}\n\n.ant-radio-wrapper:hover {\n    .ant-radio-inner {\n        border-color: var(--color-highlight) !important;\n    }\n}\n\n.vert-radio.ant-radio-wrapper .ant-radio .ant-radio-inner {\n    &::after {\n        background-color: var(--color-highlight) !important;\n        transform: scale(0.7) !important;\n    }\n}\n\n.ant-radio-wrapper .ant-radio.ant-radio-checked .ant-radio-inner {\n    border-color: var(--color-highlight) !important;\n}\n\n.ant-radio-checked::after {\n    border: var(--color-highlight-darker) !important;\n}\n\n.customer-search, .supplier-search {\n    .ant-select-selection-search {\n        padding-left: var(--spacing-small);\n    }\n}\n\n@media(max-width: 425px){\n    .collum-btn-continue {\n      button{\n        display: flex;\n        align-items: center;\n        flex-direction: row !important;\n        gap: 0px !important\n      }\n    }\n} \n\n.text-title-finish {\n    font-size: var(--font-big);\n    font-weight: 600;\n    color: var(--color-neutral-dark);\n}\n\n.quotation-file {\n    margin-left: 10px;\n    border-radius: var(--border-radius-input) !important;\n}\n\n.quotation-file:hover {\n    border-color: var(--color-highlight);\n}\n\n.important-info > span {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n\n    svg {\n        font-size: 14px;\n        margin-bottom: 3px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
